import React, { useEffect, useRef, useState } from "react";
import TokenomicsCss from "./style";
import PieCharts from "./test";

function Tokenomics() {
  const paraRef = useRef();
  const [visible, setVisible] = useState(false);
  const observer = React.useRef(
    new IntersectionObserver(
      (enteries, ob) => {
        enteries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
        });
      },
      { root: null, rootMargin: "-200px 0px", threshold: 0 }
    )
  );
  useEffect(() => {
    observer.current.observe(paraRef.current);
  }, []);

  let classes = "title";
  if (visible) {
    classes += " fadeIn";
  }

  return (
    <TokenomicsCss>
      <div className="wrapper">
        <div className={classes} ref={paraRef}>
          Tokenomics
        </div>
        <div className="content">
          <div className="left">
            <div className="data">
              <div className="text">
                <h3>24.4%</h3>
                <p>Monthly Airdrops</p>
              </div>
              <div className="color">
                <img src="chart/s1.png" alt="chartcolor"></img>
              </div>
            </div>
            <div className="data">
              <div className="text">
                <h3>20%</h3>
                <p>IFO</p>
              </div>
              <div className="color">
                <img src="chart/s2.png" alt="chartcolor"></img>
              </div>
            </div>
            <div className="data">
              <div className="text">
                <h3>12.5%</h3>
                <p>CETO Blockchain Family</p>
              </div>
              <div className="color">
                <img src="chart/s3.png" alt="chartcolor"></img>
              </div>
            </div>
            <div className="data">
              <div className="text">
                <h3>20%</h3>
                <p>Fertilizer Bag</p>
              </div>
              <div className="color">
                <img src="chart/s4.png" alt="chartcolor"></img>
              </div>
            </div>

            <div className="data">
              <div className="text">
                <h3>12.3%</h3>
                <p>CETO Bonds</p>
              </div>
              <div className="color">
                <img src="chart/s5.png" alt="chartcolor"></img>
              </div>
            </div>
          </div>

          <div className="middle">
            <PieCharts />
          </div>

          <div className="right">
            <div className="data">
              <div className="color">
                <img src="chart/s6.png" alt="chartcolor"></img>
              </div>
              <div className="text">
                <h3>4.0%</h3>
                <p>Yield Farming</p>
              </div>
            </div>
            <div className="data">
              <div className="color">
                <img src="chart/s7.png" alt="chartcolor"></img>
              </div>
              <div className="text">
                <h3>2.0%</h3>
                <p>Community Marketing</p>
              </div>
            </div>
            <div className="data">
              <div className="color">
                <img src="chart/s8.png" alt="chartcolor"></img>
              </div>
              <div className="text">
                <h3>2.0%</h3>
                <p>Locked Liquidity</p>
              </div>
            </div>
            <div className="data">
              <div className="color">
                <img src="chart/s9.png" alt="chartcolor"></img>
              </div>
              <div className="text">
                <h3>1.5%</h3>
                <p>Team</p>
              </div>
            </div>
            <div className="data">
              <div className="color">
                <img src="chart/s10.png" alt="chartcolor"></img>
              </div>
              <div className="text">
                <h3>1.3%</h3>
                <p>Development</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom">
          {/* <div className="left">
            <div className="left_data">
              <h2>$0.10</h2>
              <p>Pre-Sale Price</p>
            </div>
          </div> */}
          <div className="right">
            <div className="right_data">
              <h2>100,000,000</h2>
              <p>Total Supply</p>
            </div>
          </div>
        </div>

        {/* here is the mobile version div */}

        <div className="content_mobile">
          <div className="top">
            <PieCharts />
          </div>
          <div className="middle">
            {/* <div className="left">
              <div className="left_data">
                <h2>$0.10</h2>
                <p>Pre-Sale Price</p>
              </div>
            </div> */}
            <center>
              <div className="right">
                <div className="right_data">
                  <h2>100,000,000</h2>
                  <p>Total Supply</p>
                </div>
              </div>
            </center>
          </div>

          <div className="bottom_mob">
            <div className="left">
              <div className="data">
                <div className="color">
                  <img src="chart/s1.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>24.4%</h3>
                  <p>Monthly Airdrops</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s2.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>20%</h3>
                  <p>IFO</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s3.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>12.5%</h3>
                  <p>CETO Blockchain Family</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s4.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>20%</h3>
                  <p>Fertilizer Bag</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s5.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>12.3%</h3>
                  <p>CETO Bonds</p>
                </div>
              </div>
            </div>

            <div className="right">
              <div className="data">
                <div className="color">
                  <img src="chart/s6.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>4.0%</h3>
                  <p>Yield Farming</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s7.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>2.0%</h3>
                  <p>Community Marketing</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s8.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>2.0%</h3>
                  <p>Locked Liquidity</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s9.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>1.5%</h3>
                  <p>Team</p>
                </div>
              </div>
              <div className="data">
                <div className="color">
                  <img src="chart/s10.png" alt="chartcolor"></img>
                </div>
                <div className="text">
                  <h3>1.3%</h3>
                  <p>Development</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* mobile version ends here */}
      </div>
    </TokenomicsCss>
  );
}

export default Tokenomics;
